import { render, staticRenderFns } from "./addVoiceVant.vue?vue&type=template&id=65af4ada&scoped=true&"
import script from "./addVoiceVant.vue?vue&type=script&lang=js&"
export * from "./addVoiceVant.vue?vue&type=script&lang=js&"
import style0 from "./addVoiceVant.vue?vue&type=style&index=0&id=65af4ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af4ada",
  null
  
)

export default component.exports